export default __webpack_public_path__ + "static/media/btn_step_3_active.79ca3253.svg";